import React, { useState } from 'react'
import { useSearchParams } from '@remix-run/react'
import {
    Stack,
    Wrap,
    WrapItem,
    Text,
} from '@chakra-ui/react'

import DesktopFilterButton from './Filter/DesktopFilterButton'
import FilterAmount from './Filter/FilterAmount'
import FilterEssay from './Filter/FilterEssay'
import FilterState from './Filter/FilterState'
import SortBy from './Filter/SortBy'

const HeroDesktopFilter = () => {
    const [searchParams, setSearchParams] = useSearchParams()

    // Local State
    const [amountMin, setAmountMin] = useState(searchParams.get('amountMin') || '')
    const [amountMax, setAmountMax] = useState(searchParams.get('amountMax') || '')
    const [essay, setEssay] = useState(Boolean((searchParams.get('essay') || 'false').replace(/\s*(false|null|undefined|0)\s*/i, "")))
    // If parameter value state is a string then convert it to array, otherwise set nationwide as default value
    const [state, setState] = useState(searchParams.get('state') ? searchParams.get('state').split(',') : ['nationwide'])
    
    // Update data when "Done" is clicked
    const handleUpdate = (parameter, value) => {
        if (parameter === 'amount') {
            amountMin === undefined ? searchParams.set('amountMin', 0) : searchParams.set('amountMin', amountMin)
            amountMax === undefined ? searchParams.set('amountMax', 99999) : searchParams.set('amountMax', amountMax)
            setSearchParams(searchParams)
            return
        }
        searchParams.set('page', '1')
        searchParams.set(parameter, value)
        setSearchParams(searchParams)    
    }
    
    return (
        <Stack direction={{ base: 'column', md: 'row' }} justify={'center'}>
            <Stack direction={'column'} align={'center'}>
                <Wrap align={'center'} justify={'center'}>
                    <WrapItem>
                        <Text textColor={'white'} fontSize={'lg'}>Filter by</Text>
                    </WrapItem>
                    <WrapItem>
                        <DesktopFilterButton label={'amount'} content={<FilterAmount state={{ amountMin: amountMin, setAmountMin: setAmountMin, amountMax: amountMax, setAmountMax: setAmountMax }}/>} onClick={() => handleUpdate('amount')} />
                    </WrapItem>
                    <WrapItem>
                        <DesktopFilterButton label={'essay'} content={<FilterEssay state={{ essay: essay, setEssay: setEssay }} />} onClick={() => handleUpdate('essay', essay)} />
                    </WrapItem>
                    <WrapItem>
                        <DesktopFilterButton label={'state'} content={<FilterState state={{ selectedStates: state, setSelectedStates: setState }} />} onClick={() => handleUpdate('state', state.join(','))} />
                    </WrapItem>
                </Wrap>
            </Stack>
            <Stack direction={'row'} align={'center'} justify={'center'}>
                <Text textColor={'white'} fontSize={'lg'}>Sort by</Text>
                <SortBy />
            </Stack>
        </Stack>
    )
}

export default HeroDesktopFilter